// Single source of truth for product naming (plan D-5: "Sketcher", minimal copy).
// Changing the product name should require editing only this file.

export const PRODUCT_NAME = 'Sketcher'

export const TAGLINE = 'Fast, precise floor plans in your browser.'

/** Shown in the browser tab. */
export const DOCUMENT_TITLE = PRODUCT_NAME

/** Default name given to a freshly created drawing. */
export const DEFAULT_DOCUMENT_NAME = 'Untitled Drawing'

/** File extension used by the engine's serialized document format. */
export const DOCUMENT_EXTENSION = '.sketchjson'
